import { atom } from "jotai";
import ReelsCategory from "./Reels/ReelsCategory";

export const loginState = atom({
  isPersonal: false,
  isLogin: false,
  id: "",
  pw: "",
});

export const defaultHomeState = {
  isLogin: false,
  clickedCount: 0,
  homeNm: "",
  reelsNm: "",
  productsNm: "",
  detailNm: "",
  isViewFlags: {
    home: false,
    reels: false,
    products: false,
    detail: false,
  },
};

export const homeState = atom({
  ...defaultHomeState,
});

export const defaultHomeUpdateState = {
  homeMenuNm: "", // 홈 메뉴명: 문자열
  checkedHome: false,
  reelsMenuNm: "", // 릴스 모아보기 메뉴명: 문자열
  checkedReels: false,
  productsMenuNm: "", // 상품 소개 메뉴명: 문자열
  checkedProducts: false,
  detailMenuNm: "", // 심화 정보 메뉴명: 문자열
  checkedDetail: false,
  // 메뉴별 게시하기 플래그: json
  isViewFlags: {
    home: true, // 홈 메뉴 게시하기 플래그: bool
    reels: true, // 릴스 메뉴 게시하기 플래그: bool
    products: true, // 상품 소개 게시하기 플래그: bool
    detail: true, // 심화 정보 게시하기 플래그: bool
  },
};

export const homeUpdateState = atom({
  ...defaultHomeUpdateState,
});

export const defaultReelsCategoryState = {
  isLogin: false,
  isDim: false,
  isUpdate: false,
  isDelete: false,
  isReset: false,
  list: [],
  keyword: "",
  deletes: [],
};

export const reelsCategoryState = atom({
  ...defaultReelsCategoryState,
});

export const defaultReelsCategoryKeyword = "";

export const reelsCategoeryKeyowrd = atom(defaultReelsCategoryKeyword);

export const defaultDetailCategoryState = {
  isLogin: false,
  isDim: false,
  isUpdate: false,
  isDelete: false,
  isReset: false,
  list: [],
  keyword: "",
  deletes: [],
};

export const detailCategoryState = atom({
  ...defaultDetailCategoryState,
});

export const defaultdetailCategoryKeyword = "";

export const detailCategoeryKeyowrd = atom(defaultdetailCategoryKeyword);

export const defaultDetailListState = {
  isLogin: false,
  isDim: false,
  isUpdate: false,
  isDelete: false,
  isReset: false,
  list: [],
  keyword: "",
  deletes: [],
  title: "",
  count: 0,
};

export const detailListState = atom({
  ...defaultDetailListState,
});

export const defaultdetailListKeyword = "";

export const detailListKeyowrd = atom(defaultdetailListKeyword);
